import ListItem from '@components/ListItem'
import { Titlebar } from '@components/Titlebar/Titlebar'
import { Stack } from '@mui/material'
import { getChainIcon } from '@plug-core/utils/getChainIcon'
import WaterNeuronLogo from '@plug-core/assets/icons/waterneuron.png'
import OneSecLogo from '@plug-core/assets/icons/onesec.png'
import TCyclesLogo from '@plug-core/assets/icons/tcycles.png'
import { ROUTES } from '@utils/routes'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { BTC_ID } from '@plug-core/constants/tokenIds'

interface ListI {
  image: string
  primaryText: string
  secondaryText: string
  route: string
}

export const DeFiHub = () => {
  const { t } = useTranslation()

  const list: ListI[] = [
    {
      image: WaterNeuronLogo,
      primaryText: t('defi.stake.title'),
      secondaryText: t('defi.stake.description'),
      route: ROUTES.STAKE,
    },
    {
      image: OneSecLogo,
      primaryText: t('defi.onesec.title'),
      secondaryText: t('defi.onesec.description'),
      route: ROUTES.BRIDGE,
    },
    {
      image: getChainIcon('odin'),
      primaryText: t('defi.odin.title'),
      secondaryText: t('defi.odin.description'),
      route: ROUTES.DEPOSIT_ODIN,
    },
    {
      image: 'https://plug-cdn.s3.amazonaws.com/ckbtc.png',
      primaryText: t('defi.mint.title'),
      secondaryText: t('defi.mint.description'),
      route: ROUTES.MINT_CK(BTC_ID),
    },
    {
      image: TCyclesLogo,
      primaryText: t('defi.topup.title'),
      secondaryText: t('defi.topup.description'),
      route: ROUTES.TOPUP,
    },
  ]

  return (
    <Stack p={1.5}>
      <Titlebar title={t('defi.title')} />

      <Stack spacing={1.5} mt={2}>
        {list.map((item, index) => (
          <ListItem key={index} {...item} />
        ))}
      </Stack>
    </Stack>
  )
}
